/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { User, UserRoleMapping } from '../common/UserModel';
import { loadFromLocalStorage } from '../common/localStorage';
import { fetchUsersEndPoint } from '../common/constants';
import { asApplicationJsonBody } from '../common/graphqlJsonBody';

const initialState = {
    selectedUser: null,
    isLoading: false
}
const saveSelectedUserRequest = 'SAVE_CURRENT_USER';
const getUserRequest = 'GET_USER_REQUEST';
const getUserResponse = 'GET_USER_RESPONSE';

export const actionCreators = {

    saveSelectedUserRequest: (selectedUser: User) => async (dispatch: any) => {

        dispatch({ type: saveSelectedUserRequest, selectedUser });
        return;
    },
    getUser: (userid: number) => async (dispatch: any) => {
        dispatch({ type: getUserRequest });
        const token: string = loadFromLocalStorage("AuthToken");
        const encodedToken = 'Bearer ' + token;
        const headerDict: any = {
            'Authorization': encodedToken,
            'Content-Type': 'application/json'
        };
        const queryString = `query{
	allusers (userid:${userid}){
	count,
	data{
		userid,
		firstname,
		lastname,
status,
		emailid,
		internaluser,
		company{
			companyname
		},
		userrolemapping{
			userrole{
            roleid,
			rolename
			}
		},
        userservicelevelmapping{
            serviceLevel{
                serviceLevelId,
                serviceLevelValue
            }
        }
	}
	}
}`

        try {
            if (navigator.onLine) {
                const response = await fetch(fetchUsersEndPoint, {
                    headers: new Headers(headerDict),
                    body: asApplicationJsonBody(queryString),
                    method: 'POST'
                });

                const responseData = await response.json();

                const user: any = responseData.data.allusers.count == 1 ? responseData.data.allusers.data[0] : null;
                dispatch({ type: getUserResponse, user });
            }
        }
        catch (e) {

        }
    }
}
export const reducer = (state: any, action: any) => {
    state = state || initialState;
    switch (action.type) {
        case saveSelectedUserRequest:
            return {
                ...state,
                selectedUser: action.selectedUser,
                isLoading: false
            };
        case getUserRequest:
            return {
                ...state,
                isLoading: true
            };
        case getUserResponse:
            if (action.user != null) {
                ;
                const roleid = '', rolestring = '';
                const userdata = {
                    id: action.user.userid,
                    username: `${action.user.firstname} ${action.user.lastname}`,
                    email: action.user.emailid,
                    company: action.user.company != null ? action.user.company.companyname : '',
                    usertype: action.user.internaluser == 'Y' ? 'Internal' : 'External',
                    roles: action.user.userrolemapping.reduce((a: any, userrolemapping: UserRoleMapping) => {
                        return a + `,${userrolemapping.userrole.rolename}`;
                    }, rolestring).substr(1),
                    roleids: action.user.userrolemapping.reduce((a: any, userrolemapping: UserRoleMapping) => {
                        return a + `,${userrolemapping.userrole.roleid}`;
                    }, roleid).substr(1),
                    serviceLevel: (action.user.userservicelevelmapping != undefined && action.user.userservicelevelmapping.length > 0) ? action.user.userservicelevelmapping[0].serviceLevel.serviceLevelValue : (action.user.internaluser == 'Y') ? 4 : 3,
                };
                return {
                    ...state,
                    isLoading: false,
                    selectedUser: userdata
                };
            }
            else {
                return {
                    ...state,
                    isLoading: false,
                    selectedUser: 'nouser'
                };
            }
    }
    return state;
};
